/**
 * usageClubService.js
 * ===================
 * Cliente do GET /api/me/usage/club (C3 visao TIME — gestor sempre,
 * treinador se clube nao tem gestor).
 *
 * Retorna consumo TOTAL do clube do user logado no mes corrente, com
 * COALESCE/fallback aplicado pra recuperar ~48% de rows com club_id NULL.
 *
 * Usado por:
 *   - Widget compacto em ManagerHomePage (gestor)
 *   - Widget condicional em CoachHomePage (treinador-sem-gestor)
 *   - Pagina /meu-consumo/club (ClubUsagePage)
 *
 * Permissao runtime:
 *   - GESTOR: sempre ve seu clube
 *   - TREINADOR: ve SO se o clube tem 0 gestores
 *   - Outros: 403
 *
 * Cache em memoria: 60s.
 */
import { AZURE } from './api';

let _cache = null;
let _cacheTs = null;
const CACHE_TTL_MS = 60 * 1000;

/**
 * Busca o consumo agregado do clube do user logado.
 *
 * @param {Object} opts
 * @param {boolean} opts.force - Se true, ignora cache.
 * @returns {Promise<{
 *   club:         {club_id, club_name, has_gestor, n_gestores},
 *   subscription: {plan_key, ai_credits_monthly} | null,
 *   viewer:       {user_id, role, can_see_reason},
 *   usage_current_month: {
 *     period_start, period_end,
 *     interactions, tokens, cost_usd,
 *     by_agent: [{agent_name, interactions, tokens}, ...],
 *     fallback_applied: bool,
 *     rows_with_fallback: int
 *   }
 * } | null>}
 *
 * Retorna NULL silencioso em 403 (sem permissao) — widget deve sumir.
 */
export async function getClubUsage({ force = false } = {}) {
  const now = Date.now();
  if (!force && _cache && _cacheTs && (now - _cacheTs) < CACHE_TTL_MS) {
    return _cache;
  }
  try {
    const { data } = await AZURE.get('/me/usage/club');
    if (!data?.success) {
      throw new Error(data?.error || 'Falha ao buscar /me/usage/club');
    }
    _cache = data.data;
    _cacheTs = now;
    return _cache;
  } catch (err) {
    if (err?.response?.status === 403) {
      return null;
    }
    throw err;
  }
}

export function invalidateClubUsageCache() {
  _cache = null;
  _cacheTs = null;
}
